<!-- user sees those on the screen -->
@for (levelDef of _convertedLevels; track levelDef; let index = $index) {
    <ng-container
        [ngTemplateOutlet]="levelTemplate"
        [ngTemplateOutletContext]="{
            levelDef: levelDef,
            index: index,
            isTheVisibleRow: true
        }"
    ></ng-container>
}

<!-- these are hidden and used to calculate total width so we can use compact mode if necessary -->
<span #hiddenLevelsWrapper class="lg-pivot-table-body-level-headers--hidden">
    @for (levelDef of _convertedLevels; track levelDef; let index = $index) {
        <ng-container
            [ngTemplateOutlet]="levelTemplate"
            [ngTemplateOutletContext]="{
                levelDef: levelDef,
                index: index,
                isTheVisibleRow: false
            }"
        ></ng-container>
    }
</span>

<ng-template
    #levelTemplate
    let-levelDef="levelDef"
    let-index="index"
    let-isTheVisibleRow="isTheVisibleRow"
>
    @if (levelDef && !levelDef.hidden) {
        <div
            class="table__column table__column--header-level"
            [ngClass]="{
                'table__column--header-level-active': _maxVisibleLevel >= index,
                'table__column--header-level-highlight': _areLabelsVisible && _hoverLevel === index,
                'table__column--header-level-max-level': _maxVisibleLevel === index
            }"
            (click)="_toggleNameLevel(index, $event)"
            [lgSortByColumnIndicator]="levelDef.orderBy"
            [(sortBy)]="sortBy[index + _offset]"
            (sortByChange)="sortByChange.next(sortBy)"
            [sortByDisabled]="_sortByDisabled(levelDef, isTheVisibleRow, index)"
        >
            @if (index !== _lastIndex) {
                <lg-pivot-table-expand [level]="index"></lg-pivot-table-expand>
            }
            @if (_showDotForLastLevel(isTheVisibleRow, index)) {
                <span
                    [class.lg-pivot-table-expand--expanded]="_maxVisibleLevel === index"
                    class="lg-pivot-table-expand lg-pivot-table-expand--level"
                >
                    <lg-icon icon="icon-pivot-dot"></lg-icon>
                </span>
            }
            @if (_levelLabelVisible(isTheVisibleRow, index)) {
                @if (!levelDef.headerHtml) {
                    <span>{{ levelDef.header }}</span>
                }
                @if (levelDef.headerHtml) {
                    <span [innerHTML]="levelDef.headerHtml"></span>
                }
            }
        </div>
    }
</ng-template>
